import React, { useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import { Accordion } from "@material-ui/core";
import { AccordionSummary } from "@material-ui/core";
import { AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import "./../widget.css";
import axios from "axios"
import parse from 'html-react-parser';
import { useSelector } from 'react-redux';
import { contentLanding } from "./../../../../SearchPage/_redux/searchCrud";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    heading: {
        fontSize: theme.typography.pxToRem(21),
        fontWeight: theme.typography.fontWeightRegular,
        // fontSize:theme.typography.fontSize=17,
    },
    des: {
        fontSize: theme.typography.pxToRem(18),
        lineHeight: "2",
    },
}));

const Cards = styled.div`
  position: relative;
  padding: 0px;
  margin-top: 4rem;
`;

const SingleCard = styled.div`

  background: white;

  -webkit-box-shadow: 0px 0px 25px 2px rgba(49, 46, 14, 0.38);
  box-shadow: 0px 3px 5px 2px rgba(49 46 14 / 10%);

  flex: 1;
  top: 40px;
  padding: 0px;
  border-radius: 20px;

  position: relative;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Content = styled.div`
    height: ${(props) => props.height ? props.height : ""};
`;

const Text = styled.p`
  font-size: 15px;
  margin-top: 15px;
  color: #7d7d80;
  padding: 20px;
  text-align: initial;
`;

const Title = styled.h2`
    font-weight: bold;
`;

const More = styled.div`
    cursor: pointer;
`;

const ReadMore = ({ children }) => {
    console.log("child", children)
    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };
    return (
        <p className="text">
            {isReadMore ? text.slice(0, 0) : text}
            <span onClick={toggleReadMore} className="read-or-hide">
                {isReadMore ? "ادامه مطلب..." : " مختصر کنید..."}
            </span>
        </p>
    );
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function SearchLanding() {

    const classes = useStyles();
    const [value, setValue] = useState(0);
    const [content, setContent] = useState([]);

    let { state: resState } = useSelector((state) => ({
        state: state.reserve,
    }));
    const data = resState.mockTravels[0];
    const sourceTownshipId = data ? data.sourceTownshipId : 620
    const destTownshipId = data ? data.destTownshipId : 543

    useEffect(() => {

        const params = {
            sourceTownshipId: sourceTownshipId,
            destTownshipId: destTownshipId
        }
        if (sourceTownshipId != null && destTownshipId != null) {
            contentLanding({params})
                .then((res) => {
                    res.data.data.length > 0 && setContent(JSON.parse(res.data?.data[0].content))
                })
        }
    }, [sourceTownshipId, destTownshipId]);

    return (
        <>
            {
                sourceTownshipId && destTownshipId &&
                <>
                    <Cards>
                        <SingleCard id="landingCard">
                            <Content className='landingCard'>
                                <div className="container col-md-12 col-sm-12">

                                    {
                                        content ? content.map((item, index) => {

                                            return (
                                                // <ReadMore key={index}>
                                                <Text key={index} className='pb-0 pt-15'>
                                                    <Title>
                                                        {item.title}
                                                    </Title>
                                                    <p>
                                                        {
                                                            parse(item.content
                                                                .replace(/ebus/g, "<a href='https://ebus.ir'> ebus </a>")
                                                            )
                                                        }
                                                    </p>
                                                </Text>
                                                // </ReadMore>
                                            )
                                        }) : null
                                    }

                                </div>
                            </Content>
                        </SingleCard>
                    </Cards>
                </>
            }

            <div className="mt-15 mx-0">
                <div className="d-flex container-fluid mx-auto">
                    <h2 style={{ marginTop: "35px" }}>
                        <b>سوالات متداول</b>
                    </h2>
                </div>
                <div className={`${classes.root} `}>
                    <TabPanel value={value} index={0}>
                        <Accordion className="mt-2 mb-5 p-1" style={{ boxShadow: "none" }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                            //   id="panel1a-header"
                            >
                                <HelpOutlineOutlinedIcon
                                    className="mr-4"
                                    style={{ color: "green" }}
                                    fontSize="large"
                                />
                                <Typography className={classes.heading}>
                                    اتوبوس های تهران رشت ایباس در چه ساعتی از ترمینال حرکت می کنند؟
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography className={classes.des}>
                                    <>
                                        ساعت حرکت اتوبوس VIP تهران رشت، بستگی به انتخاب سرویس شما موقع خرید دارد. در طول شبانه روز اتوبوس های ایباس از تهران به رشت در ساعت های مختلفی حرکت می کنند و شما بسته به زمان سفرخود می توانید بلیط اتوبوس تهران رشت پایانه غرب مورد نظر خود را خریداری کنید.
                                    </>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion className="mt-2 mb-5 p-1" style={{ boxShadow: "none" }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                            //   id="panel1a-header"
                            >
                                <HelpOutlineOutlinedIcon
                                    className="mr-4"
                                    style={{ color: "green" }}
                                    fontSize="large"
                                />
                                <Typography className={classes.heading}>
                                    <>برای سفر با اتوبوس  VIP تهران رشت تا چه مقدار بار مجاز می توان با خود حمل کرد ؟</>
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography className={classes.des}>

                                    طبق قوانین سازمان حمل و نقل جاده ای هر مسافر اتوبوسی از تهران به رشت می تواند تا 20 کیلوگرم بار مجاز با خود جابه جا کند. اگر میزان بارمسافری، بیشتر از این میزان باشد. از طریق باربری شرکت اتوبوسی با پرداخت هزینه جابه جایی می تواند بار خود را با اتوبوس تهران ب رشت جابه جا کند.

                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion className="mt-2 mb-5 p-1" style={{ boxShadow: "none" }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                            //   id="panel1a-header"
                            >
                                <HelpOutlineOutlinedIcon
                                    className="mr-4"
                                    style={{ color: "green" }}
                                    fontSize="large"
                                />
                                <Typography className={classes.heading}>
                                    مسافت تهران تا رشت از ترمینال غرب تهران
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography className={classes.des}>
                                    مسافت تهران از ترمینال غرب تا رشت، حدود 327 کیلومتر می باشد.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion className="mt-2 mb-5 p-1" style={{ boxShadow: "none" }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                            //   id="panel1a-header"
                            >
                                <HelpOutlineOutlinedIcon
                                    className="mr-4"
                                    style={{ color: "green" }}
                                    fontSize="large"
                                />
                                <Typography className={classes.heading}>
                                    از ترمینال غرب تهران تا رشت چند ساعت فاصله است ؟
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography className={classes.des}>
                                    فاصله زمانی مسیر اتوبوسی تهران ب رشت ترمینال غرب 4  ساعت به طول می انجامد تا با اتوبوس ایباس ازتهران به رشت برسید.

                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion className="mt-2 mb-5 p-1" style={{ boxShadow: "none" }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                            //   id="panel1a-header"
                            >
                                <HelpOutlineOutlinedIcon
                                    className="mr-4"
                                    style={{ color: "green" }}
                                    fontSize="large"
                                />
                                <Typography className={classes.heading}>
                                    برای سفر با اتوبوس ایباس از تهران به رشت چند دقیقه قبل از حرکت اتوبوس در ترمینال حاضر باشیم ؟
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography className={classes.des}>

                                    اگر با محیط ترمینال غرب آشنا هستید 15 دقیقه قبل از حرکت اتوبوس تهران ب رشت ایباس در محل حرکت اتوبوس ها حضور داشته باشید. اتوبوس های ایباس به موقع و بدون تاخیر از مبدا تهران به رشت حرکت می کنند.

                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion className="mt-2 mb-5 p-1" style={{ boxShadow: "none" }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                            //   id="panel1a-header"
                            >
                                <HelpOutlineOutlinedIcon
                                    className="mr-4"
                                    style={{ color: "green" }}
                                    fontSize="large"
                                />
                                <Typography className={classes.heading}>
                                    آیا امکان کنسلی بلیط اتوبوس تهران به رشت و استرداد وجه آن وجود دارد ؟
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography className={classes.des}>
                                    <p>
                                        بله، امکان کنسلی بلیط اتوبوس تهران به رشت از سایت ایباس وجود دارد.
                                    </p>
                                    <p>
                                        و در صورتی که کمتر از یک ساعت مانده به حرکت اتوبوس قصد لغو سفر اتوبوس تهران رشت خود را داشتید با کسر 50 درصد از مبلغ خریداری شده بلیط اتوبوس خود را لغو کنید.
                                    </p>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    </TabPanel>
                </div>

            </div>
        </>
    )
}

export default SearchLanding
